function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#82a53c;}.cls-2{fill:#c4d82e;}.cls-3{fill:#9fbc2e;}.cls-4{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "logo-stacked");

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 27.4,
  width: 80.83,
  height: 430.8
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-2",
  points: "790.89 174.98 615.91 174.98 615.91 0 535.08 0 535.08 174.98 360.1 174.98 360.1 255.81 535.08 255.81 535.08 430.8 615.91 430.8 615.91 255.81 790.89 255.81 790.89 174.98"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-3",
  points: "412.28 57.16 355.13 0 177.54 177.58 177.91 177.95 140.25 215.61 177.7 253.06 177.54 253.21 355.13 430.8 412.28 373.64 254.04 215.4 412.28 57.16"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M176.54,826.38l26-26.13h9.14l-28.51,28.42,29.42,32.53h-9.32l-24.94-28L176.54,835V861.2h-6.76v-61h6.76Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M254.11,806.65H229.26v18.09h24.12v6.39H229.26V854.8h24.85v6.4H222.5v-61h31.61Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M301.07,844H275.12l-7.31,17.18h-7.49l28.05-63.87,27.32,63.87H308.2Zm-2.65-6.4-10.23-24.4-10.42,24.4Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M336.06,806.65V861.2H329.3V806.65H314.49v-6.4h36.37v6.4Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M367.58,800.25v61h-6.77v-61Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M384.2,861.2V797.69l47.51,49.8V800.25h6.77v63.69L391,814.14V861.2Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M486.53,830.59h25.4v1.46c0,6.76-2,14.07-5.85,19.28-1.83,2.46-8.68,11-22.66,11-18.09,0-31.61-13.8-31.61-31.52s13.61-31.53,31.8-31.53a30.38,30.38,0,0,1,18.64,6,37.49,37.49,0,0,1,7,7.21l-5,4.57a32,32,0,0,0-5.75-6.3,22.36,22.36,0,0,0-14.8-5.12c-14.71,0-24.95,11.06-24.95,25.22,0,16.63,13.25,25,24.76,25,8.13,0,15.17-4.11,18.64-10.23a19.18,19.18,0,0,0,2.47-8.68H486.53Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M570.49,838.09a54.13,54.13,0,0,1-5.39,6.29l7.11,9.2h-5.84l-4.57-5.9c-3.68,3.68-8.82,6.66-13.64,6.66-6.92,0-12.25-5-12.25-11.74a12,12,0,0,1,3.8-8.75,47.35,47.35,0,0,1,7.11-5.27c-2.85-3.69-4.19-6.22-4.19-9.08a8.77,8.77,0,0,1,9.21-9c5.9,0,8.94,4.26,8.94,8.51,0,2-.57,4.76-3.93,7.68-1.08,1-.7.44-3.43,2.73l8.82,11.36a57,57,0,0,0,4.83-5.59Zm-20.94-6a37.94,37.94,0,0,0-6,4.38,7.65,7.65,0,0,0-3,6.09,7.31,7.31,0,0,0,7.49,7.49c4.51,0,9.27-4.32,10.86-5.84Zm1.14-6,2.8-2.16c2.41-1.9,2.85-3.43,2.85-4.89a4.31,4.31,0,0,0-4.57-4.38,4.6,4.6,0,0,0-4.7,4.64,6.82,6.82,0,0,0,1.72,4.19Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M642.19,813.68a29.93,29.93,0,0,0-8-5.66,26,26,0,0,0-10.51-2.38c-14.07,0-24.49,11.33-24.49,25.4,0,16.54,13.44,24.85,24.58,24.85a25.29,25.29,0,0,0,11.34-2.83,27.8,27.8,0,0,0,7-5.11v8.4a31.69,31.69,0,0,1-18.37,5.94c-18.09,0-31.52-13.7-31.52-31.34,0-18.18,13.62-31.71,31.89-31.71a28.72,28.72,0,0,1,18,6Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M646.75,830.77c0-18.18,14.16-31.53,31.7-31.53s31.71,13.35,31.71,31.53-14.07,31.52-31.71,31.52S646.75,848.86,646.75,830.77Zm6.94,0a24.77,24.77,0,1,0,24.76-25.13A24.86,24.86,0,0,0,653.69,830.77Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M716,861.2l10.15-64.33,23.39,51.44,23.84-51.53,9.51,64.42h-6.95l-5.76-42.4-20.74,45L729,818.8l-6,42.4Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M803.52,800.25c6.13,0,11.24.73,15.35,4.3,4.48,3.83,5.58,9.22,5.58,13.06,0,8.59-5.39,17.09-19.28,17.09h-5.94v26.5h-6.76v-61Zm-4.29,28h5.57c8.05,0,12.89-4,12.89-11.06,0-9.68-9.05-10.59-13.44-10.59h-5Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M860.35,844H834.41L827.1,861.2h-7.5l28.06-63.87L875,861.2h-7.49Zm-2.64-6.4-10.24-24.4-10.41,24.4Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M880.91,861.2V797.69l47.51,49.8V800.25h6.76v63.69l-47.51-49.8V861.2Z",
  transform: "translate(-169.78 -269.92)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M961.12,835l-20-34.72H949l15.53,27.23,15.72-27.23h7.85L967.88,835V861.2h-6.76Z",
  transform: "translate(-169.78 -269.92)"
});

var SvgLogoStacked = function SvgLogoStacked(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 818.29 594.01",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoStacked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-stacked.c651e3cb.svg";
export { ForwardRef as ReactComponent };